import { alias, createModelSchema } from "serializr";
import { Cloneable } from "./Cloneable";
import { Schema } from "@/common/Schema";
import { uuid } from "vue-uuid";

export class BaseObject extends Cloneable {

    constructor() {
        super();
        this._uid = uuid.v4().replace(/-/g, "");

        this._global = false;
        this._shared = false;
        this._export = false;
        this._locked = false;
        this._enabled = false;
        this._changed = false;
    }

    get uid() {
        return this._uid;
    }

    get global() {
        return Boolean(this._global);
    }

    set global(value) {
        this._global = value;
    }

    get shared() {
        return Boolean(this._shared);
    }

    set shared(value) {
        this._shared = value;
    }

    get export() {
        return Boolean(this._export);
    }

    set export(value) {
        this._export = value;
    }

    get locked() {
        return Boolean(this._locked);
    }

    set locked(value) {
        this._locked = value;
    }

    get enabled() {
        return Boolean(this._enabled);
    }

    set enabled(value) {
        this._enabled = value;
    }

    get changed() {
        return this._changed;
    }

    set changed(value) {
        this._changed = value;
    }

    valid() {
        return true;
    }

    empty() {
        return false;
    }

    copy() {
        let value = this.clone();
        value._uid = uuid.v4().replace(/-/g, "");
        value._export = false;
        value._global = false;
        value._shared = false;
        value._changed = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new BaseObject());
        } else if (target instanceof BaseObject) {
            return super.clone(target);
        } else {
            return undefined;
        }
    }
}

createModelSchema(BaseObject, {
    _uid: alias("uid", Schema.primitive()),

    _export: alias("export", Schema.primitive()),
    _locked: alias("locked", Schema.primitive()),
    _enabled: alias("enabled", Schema.primitive())
});
